module.exports = __webpack_public_path__ + "static/img/public.e92a76f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/public.png
// module id = iXCM
// module chunks = 1